import { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { ArrowRight, ArrowLeft } from 'lucide-react';
import { useMobile } from './MobileContext';

export const MBack = ({ to, label }) => {
  const { t, isRTL } = useMobile();
  const nav = useNavigate();
  return (
    <button onClick={() => (to ? nav(to) : nav(-1))} data-testid="m-back"
      className="inline-flex items-center gap-1.5 h-9 px-3.5 rounded-full bg-white border border-slate-200 shadow-sm text-sm font-bold text-slate-800 active:bg-slate-100">
      {isRTL ? <ArrowRight className="w-4 h-4 text-[#D4AF37]" /> : <ArrowLeft className="w-4 h-4 text-[#D4AF37]" />}
      {label || t('رجوع', 'Back')}
    </button>
  );
};

export const MWelcome = () => {
  const { content, isRTL, t } = useMobile();
  const s = content.bank || {};
  const [seen, setSeen] = useState(() => localStorage.getItem('azizi_welcome_seen') === '1');
  if (seen || s.welcome_enabled === false || content.loading) return null;
  if (!s.welcome_title_ar && !s.welcome_text_ar) return null;
  const done = () => { localStorage.setItem('azizi_welcome_seen', '1'); setSeen(true); window.dispatchEvent(new Event('azizi:welcome-done')); };
  return (
    <div className="fixed inset-0 z-50 bg-[#0F172A] text-white flex flex-col items-center justify-center p-8 text-center max-w-md mx-auto" dir={isRTL ? 'rtl' : 'ltr'} data-testid="m-welcome">
      <img src="/logo-rounded.png" alt="AZIZI" className="w-24 h-24 rounded-3xl mb-6 shadow-2xl" />
      <h1 className="text-xl font-bold">{isRTL ? s.welcome_title_ar : (s.welcome_title_en || s.welcome_title_ar)}</h1>
      <p className="text-sm text-white/65 mt-4 leading-relaxed whitespace-pre-line">{isRTL ? s.welcome_text_ar : (s.welcome_text_en || s.welcome_text_ar)}</p>
      <button onClick={done} className="mt-8 h-12 w-full rounded-2xl bg-[#D4AF37] text-[#0F172A] text-sm font-bold shadow-lg" data-testid="m-welcome-start">{isRTL ? (s.welcome_button_ar || t('ابدأ الآن', 'Get started')) : (s.welcome_button_en || 'Get started')}</button>
    </div>
  );
};
